import useAlertBar from "@/hooks/useAlertBar";
import { recordFreightService } from "@/services/rateService";
import React, { useState } from "react";
import { MdMail, MdPhone } from "react-icons/md";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
  Button,
} from "reactstrap";

const LTLQuoteModal = ({ open, toggleModal, ratesRequestBody, isFTL }: any) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const { openAlertBar } = useAlertBar();

  const handleSubmit = async () => {
    try {
      if (!email || !username) {
        openAlertBar(
          "Please provide your contact details for better assistance",
          false
        );
      }

      ratesRequestBody["guestEmail"] = email;
      ratesRequestBody["guestName"] = username;
      ratesRequestBody["loadType"] = isFTL ? "FTL" : "LTL";

      await recordFreightService(ratesRequestBody);

      toggleModal();
      openAlertBar(
        "We appreciate your patience, Someone from our team will reach out to you shortly.",
        true
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>
        {isFTL ? "FTL" : "LTL"} Shipping Quote
      </ModalHeader>
      <ModalBody className="text-center">
        <h4>Important Update Regarding Your Shipping Quote Request</h4>
        <br />
        <p>
          We express our sincere gratitude for choosing ShipVista as your
          trusted shipping partner. Your decision to rely on our services means
          a great deal to us, and we are committed to providing you with the
          best possible shipping solutions tailored to your needs. We understand
          that you are currently looking for shipping quote, and we apologize
          that quotes for this route are not available online at the moment.
          However, there is no need to worry, as our dedicated{" "}
          {isFTL
            ? `FTL (Full Truckload)`
            : `LTL (Less Than
          Truckload)`}{" "}
          shipping team is well-prepared to assist you in obtaining the most
          competitive quote for your shipment.
        </p>
        <br />
        <h6>
          Please fill out below details, to receive quote to directly to your
          email.
        </h6>
        <Row style={{ alignItems: "center" }}>
          <Col sm="12" md="5">
            <FormGroup floating>
              <Input
                onChange={({ target }) => setUsername(target.value)}
                name="username"
                placeholder="Your Name"
                type="text"
                value={username}
              />
              <Label for="username">
                Name <span className="text-danger">*</span>{" "}
              </Label>
            </FormGroup>
          </Col>
          <Col sm="12" md="5">
            <FormGroup floating>
              <Input
                onChange={({ target }) => setEmail(target.value)}
                name="email"
                placeholder="Your Name"
                type="text"
                value={email}
              />
              <Label for="email">
                Email <span className="text-danger">*</span>{" "}
              </Label>
            </FormGroup>
          </Col>
          <Col>
            <Button color="primary" onClick={handleSubmit} className="mb-3">
              Submit
            </Button>
          </Col>
        </Row>
        <p>- or -</p>

        <p>
          <b>
            If you require immediate assistance, please contact us using the
            details provided below.
          </b>
        </p>
        <p>
          <Row justify="space-around" spacing={2}>
            <Col className="text-info" item>
              <MdMail /> <a href="mailto:">customercare@shipvista.com</a>
            </Col>
            <Col className="text-info" item>
              <MdPhone /> <a href="tel:9053468044">(905) 346-8044</a> - Ext #2.
            </Col>
            <Col className="text-info" item>
              <MdPhone /> <a href="tel:8554343477">855-434-3477</a> - Ext #2.
            </Col>
          </Row>
        </p>
        <br />
        <p>
          Business Hours: <br />
          <b className="text-primary">Monday to Friday: 10 am to 7:30 pm EST</b>
          .
        </p>
      </ModalBody>
    </Modal>
  );
};

export default LTLQuoteModal;
